module.exports = new __parcel__URL__("torpedo.3fd5eec3.png").toString();